/**
 * @generated SignedSource<<f929aa41096aedd32924303a0020e84e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PostStatusEnum = "acfDisabled" | "archived" | "autoDraft" | "dpRewriteRepublish" | "draft" | "future" | "inherit" | "pending" | "private" | "publish" | "requestCompleted" | "requestConfirmed" | "requestFailed" | "requestPending" | "trash" | "%future added value";
export type PostTemplateEnum = "brandedFullWidth" | "brandedPortrait" | "fullWidth" | "specialFeatureFullWidth" | "specialFeatureOverlay" | "specialFeatureSquare" | "square" | "%future added value";
export type ResourceTypeEnum = "authorProfile" | "campaign" | "category" | "clientError" | "customStory" | "diningReport" | "embedStory" | "homepage" | "image" | "internalCategory" | "internalSuperCat" | "linkPost" | "loopNav" | "map" | "mmaEvent" | "mmaFight" | "mmaFighter" | "mmaPromotion" | "mmaWeightClass" | "neighborhood" | "package" | "page" | "post" | "product" | "productBrand" | "quickPost" | "redirect" | "series" | "startHere" | "stream" | "superCat" | "tag" | "vault" | "venue" | "videoGame" | "videoGamePlatform" | "videoPost" | "volumeVideo" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentAdsContainer_contentResource$data = {
  readonly __typename: string;
  readonly authors?: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly categories?: ReadonlyArray<{
    readonly isHub: boolean;
    readonly slug: string;
  }>;
  readonly chorusId: number | null;
  readonly dek: {
    readonly plaintext: string;
  };
  readonly excludedFromHomepage?: boolean;
  readonly globalId: string;
  readonly id: string;
  readonly internalCategories?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly internalSuperCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly originalPublishedAt: string | null;
  readonly packages?: {
    readonly nodes: ReadonlyArray<{
      readonly globalId: string;
    }>;
  } | null;
  readonly permalink: string;
  readonly primaryCampaign: {
    readonly advertiserName: string;
    readonly title: string;
  } | null;
  readonly primaryCategory?: {
    readonly isHub: boolean;
    readonly parent: {
      readonly slug: string;
    } | null;
    readonly slug: string;
  };
  readonly resourceType: ResourceTypeEnum;
  readonly seo: {
    readonly headline: string;
  };
  readonly status: PostStatusEnum;
  readonly superCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly template?: PostTemplateEnum | null;
  readonly title: string;
  readonly " $fragmentType": "ContentAdsContainer_contentResource";
};
export type ContentAdsContainer_contentResource$key = {
  readonly " $data"?: ContentAdsContainer_contentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentAdsContainer_contentResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHub",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentAdsContainer_contentResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourceType",
      "storageKey": null
    },
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permalink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalPublishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RichTextType",
      "kind": "LinkedField",
      "name": "dek",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plaintext",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShareableDataType",
      "kind": "LinkedField",
      "name": "seo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CampaignResourceType",
      "kind": "LinkedField",
      "name": "primaryCampaign",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "advertiserName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "excludedFromHomepage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorProfileResourceType",
          "kind": "LinkedField",
          "name": "authors",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "primaryCategory",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CategoryResourceType",
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": (v3/*:: as any*/),
              "storageKey": null
            },
            (v2/*:: as any*/),
            (v4/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalSuperCatResourceType",
          "kind": "LinkedField",
          "name": "internalSuperCats",
          "plural": true,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SuperCatResourceType",
          "kind": "LinkedField",
          "name": "superCats",
          "plural": true,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalCategoryResourceType",
          "kind": "LinkedField",
          "name": "internalCategories",
          "plural": true,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            (v4/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "FeedContentResourceInterfacePackagesConnection",
          "kind": "LinkedField",
          "name": "packages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PackageResourceType",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "packages(first:100)"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "template",
              "storageKey": null
            }
          ],
          "type": "PostResourceType",
          "abstractKey": null
        }
      ],
      "type": "FeedContentResourceInterface",
      "abstractKey": "__isFeedContentResourceInterface"
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};
})();

(node as any).hash = "5ccc0c99ea7e5b52a3abd211731f8f21";

export default node;
